module.exports = __webpack_public_path__ + "img/zhuan1.08c1a390.png";